module.exports = __webpack_public_path__ + "static/img/plate_title_2.52fb27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/plate_title_2.png
// module id = PLLw
// module chunks = 60